<template>
  <BaseView :categories="categories" :spus="spus" :current-category="currentCategory"
    :current-spu="currentSpu" :plan="$t('pricing.residential.title')" :introduction="$t('pricing.residential.intro')">
    <template v-slot:skus>
      <BuyResidentialProxyView :currentSpu="currentSpu" @buy-now="clickBuyPlan"></BuyResidentialProxyView>
    </template>
    <template v-slot:dialog>
      <PaymentView v-if="showPaymentView" @close="handleClosePaymentView" ref="paymentView"></PaymentView>
    </template>

  </BaseView>
</template>

<script>
import BaseView from "./base.vue"
import BuyResidentialProxyView from "@/components/buy-residential-proxy-view.vue"
import PaymentView from "../payment/payment-view.vue"

export default {
  name: 'residential',
  components: {
    BaseView,
    BuyResidentialProxyView,
    PaymentView
  },

  data() {
    return {
      Loading: false,
      showPaymentView: false,

      activeCategoryName: 'rotating',

      categories: [
        { name: 'static', url: '/staticisp/'},
        { name: 'rotating', url: '/residential/'},
      ],

      spus: [
        { name: 'Residential Proxies', url: '/residential/',},
      ],
    }
  },
  computed: {
    currentCategory() {
      return this.categories.find(category => category.name === this.activeCategoryName) || { name: '', url: '' };
    },
    currentSpu() {
      return this.$t("pricing.residential.spu");
    },
    isLogin() {
      return this.$store.state.isLogin
    },
  },
  methods: {
    clickBuyPlan: function (item) {
      let that = this;
      if (this.isLogin) {
        item.source = '/residential';
        that.showPaymentView = true;
        that.$nextTick(() => {
          if (that.$refs.paymentView) {
            that.$refs.paymentView.updateInfo(item)
          }
        })
      } else {
        that.$router.push({path:'/login', query: {redirect: this.$route.fullPath}})
      }
    },

    handleClosePaymentView() {
      this.showPaymentView = false;
    },
  }
}

</script>